var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:{'card--loading':_vm.loading}},[(_vm.loading)?_c('div',{staticClass:"card__loader"},[_c('loading-spinner')],1):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }